import Modal from 'react-modal'
import IconDone from '~/assets/images/done.svg'
import { ModalCloseIcon } from '~/components/icons'
import { LottieLoading } from '~/components/Loading'
import { useBreakpoint } from '~/hooks'
import { STATUS } from '../../types'
import { StyledModalContent } from './styled'

const StatusModal = ({ titles, subtitles, onClose, status }) => {
  const { isMobile } = useBreakpoint()
  const idx = status === STATUS.DOING ? 0 : 1

  return (
    <Modal
      isOpen={status !== STATUS.NOT_YET}
      contentLabel="LON stake Modal"
      onRequestClose={onClose}
      style={{
        content: {
          bottom: isMobile ? 0 : 'auto',
          margin: '0 auto',
          border: 0,
          marginTop: 'calc(55vh - 230px)',
          backgroundColor: 'transparent',
          top: 'auto',
          left: '0',
          right: '0',
          borderRadius: '8px',
          padding: '0',
        },
        overlay: {
          zIndex: 101,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
      }}
      appElement={typeof document !== 'undefined' ? document.body : null}
    >
      <StyledModalContent>
        <div
          className="content loading"
          style={{
            paddingBottom: isMobile ? 40 : 10,
            backgroundColor: '#262C4B',
          }}
        >
          {idx === 0 ? <LottieLoading /> : <img src={IconDone} />}
          <p className="title">{titles[idx]}</p>
          <p className="subtitle">{subtitles[idx]}</p>
          <ModalCloseIcon className="modal-close" onClick={onClose} />
        </div>
      </StyledModalContent>
    </Modal>
  )
}

export default StatusModal
